export const MODAL_SHOW = 'MODAL_HIDE'
export const MODAL_HIDE = 'MODAL_SHOW'
